"use strict";

import * as angular from "angular";
import {component} from "./decorators/Component";
import {MyPositionController} from "./components/MyPosition";
import {PaginationController} from "./components/Pagination";
import {PaginationControlController} from "./components/PaginationControl";
import {PaginationInternalController} from "./components/PaginationInternal";
import {PaginationSpinnerController} from "./components/PaginationSpinner";

export let playPagination:angular.IModule = angular.module("playPagination", [
    "pascalprecht.translate"
]);

playPagination.config(["$translateProvider", function($translateProvider) {
    $translateProvider.translations("en", {
        "pagination:my-position": "My Position",
        "pagination:no-pages": "No Pages",
    });
}]);

playPagination.config(["$httpProvider", "$compileProvider", (
    $httpProvider:angular.IHttpProvider,
    $compileProvider:angular.ICompileProvider
) => {
    $httpProvider.useApplyAsync(true);
    $compileProvider.debugInfoEnabled(false);
}]);

playPagination.component("playPaginationMyPosition", component({
    bindings: {
        leagueId: "<",
        contestant: "<",
        permalink: "<",
        getData: "&"
    },
    templateCacheUrl: "pagination/my-position.html",
    controllerAs: "ctrl",
    require: {
        pagination: "^playPagination"
    },
    controller: MyPositionController
}));

playPagination.component("playPagination", component({
    bindings: {
        limit: "<",
        permalink: "<",
        data: "=",
        watcher: "<",
        loading: "=",
        getData: "&"
    },
    templateCacheUrl: "pagination/pagination.html",
    controllerAs: "ctrl",
    transclude: true,
    controller: PaginationController
}));

playPagination.component("playPaginationControl", component({
    bindings: {},
    templateCacheUrl: "pagination/pagination-control.html",
    controllerAs: "ctrl",
    require: {
        pagination: "^playPaginationInternal"
    },
    controller: PaginationControlController
}));

playPagination.component("playPaginationInternal", component({
    bindings: {
        limit: "<",
        offset: "<",
        total: "<",
        watcher: "<",
        data: "<"
    },
    templateCacheUrl: "pagination/pagination-internal.html",
    controllerAs: "ctrl",
    transclude: true,
    require: {
        paginationCtrl: "^playPagination"
    },
    controller: PaginationInternalController
}));

playPagination.component("playPaginationSpinner", component({
    templateCacheUrl: "pagination/spinner.html",
    controller: PaginationSpinnerController
}));